import React, { useEffect, useRef, useState } from "react";
import { Button, Icon } from "../ui";
import ChatIcon from "./ChatIcon";

/** เมนูปุ่ม ... แบบเปิด/ปิดเอง (คลิกนอกกล่อง/Esc ปิด) — items: [{label, onClick, icon, danger, badge}] */
export default function PopMenu({ label = "เมนู", items, up, trigger, className }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    const esc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", esc);
    };
  }, [open]);
  return (
    <div className={`rel popmenu${className ? ` ${className}` : ""}`} ref={ref}>
      {trigger ? (
        React.cloneElement(trigger, { "aria-haspopup": "menu", "aria-expanded": open, onClick: () => setOpen((v) => !v) })
      ) : (
        <Button size="sm" icon variant="ghost" aria-label={label} aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((v) => !v)}><Icon name="more" /></Button>
      )}
      {open ? (
        <div className={`menu popmenu__list${up ? " popmenu__list--up" : ""}`} role="menu">
          {items.map((it) => (
            <button key={it.label} role="menuitem" className={it.danger ? "is-danger" : ""} onClick={() => { setOpen(false); it.onClick?.(); }}>
              {it.icon ? <ChatIcon name={it.icon} size={17} /> : null}
              <span className="grow">{it.label}</span>
              {it.badge ? <span className="chip chip--sm">{it.badge}</span> : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
